import * as R from 'ramda'

import useAxios from 'hooks/useAxios'

export default function useFeatureToggle() {
  const { data, error } = useAxios({
    url: 'dashboard/feature-toggle/',
  })

  const isLoading = data === undefined && error === undefined

  const enableNewBillingPlan = R.propOr(false, 'enable_new_billing_plan', data)
  const enableNewPlanCardUI = R.propOr(false, 'enable_new_plan_card_ui', data)
  const enableResponseRate = R.propOr(false, 'enable_response_rate', data)
  const enableWorkspaceWeekStart = R.propOr(false, 'enable_workspace_week_start', data)
  const enableTypeDatetimeAttribute = R.propOr(false, 'enable_type_datetime_attribute', data)
  const enableRelativeDateAudienceFilter = R.propOr(
    false,
    'enable_relative_date_audience_filter',
    data
  )
  const enableBillingTaxId = R.propOr(false, 'enable_billing_tax_id', data)
  const enableBillingUsTax = R.propOr(false, 'enable_billing_us_tax', data)
  const enableRatingChoiceOrder = R.propOr(false, 'enable_rating_choice_order', data)
  const enableMetricReorder = R.propOr(false, 'enable_metric_reorder', data)
  const enableCtaButtonVariables = R.propOr(false, 'enable_cta_button_variables', data)
  const enableFileUploadQuestion = R.propOr(false, 'enable_file_upload_question', data)
  const enableBenchmarks = R.propOr(false, 'enable_benchmarks', data)
  const enableScoreOverTime = R.propOr(false, 'enable_score_over_time', data)
  const enableNoRatingResponseNotification = R.propOr(
    false,
    'no_rating_response_notification',
    data
  )

  return {
    isLoading,
    enableNewBillingPlan,
    enableNewPlanCardUI,
    enableResponseRate,
    enableWorkspaceWeekStart,
    enableTypeDatetimeAttribute,
    enableRelativeDateAudienceFilter,
    enableBillingTaxId,
    enableBillingUsTax,
    enableRatingChoiceOrder,
    enableMetricReorder,
    enableCtaButtonVariables,
    enableFileUploadQuestion,
    enableBenchmarks,
    enableScoreOverTime,
    enableNoRatingResponseNotification,
  }
}



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/hooks/useFeatureToggle/index.js